import storeManager from "store/manager";

const getSymbolDigit = (symbol: string) => {
    const digit = storeManager.symbol.getGroup().symbols?.find((symbol: any) => symbol.symbol === symbol)?.digits || null;
    
    return digit;
}

export default getSymbolDigit;